<script>
  import {_} from 'svelte-i18n'
  import {isShowSearchLoader, searchTitle} from "../../stores";
  import PreviewCard from "../PreviewCard/PreviewCard.svelte";

  export let searchResults
</script>

{#if $searchTitle }
<div class="search-title">
  <div>{$_('searchResults')} «{$searchTitle}»</div>
</div>
{/if}

<div class="search-results">
  {#each searchResults as result (result.order)}
    {#if result }
      <div class="{'order-' + result.order}">
        {#if Array.isArray(result.list) }
          <div class="feed-group-result" class:visibility-hidden={$isShowSearchLoader}>
            <div>{ result.title }</div>
            {#if result.list.length }
              <span>{$_('found')}: { result.count }</span>
            {:else}
              <span>{$_('searchNotFound')}</span>
            {/if}
          </div>

          {#each result.list as publication (publication.id)}
            <PreviewCard {publication} fixPublication={publication.fix}/>
          {/each}
        {:else}
          <div class="feed-group-result" class:visibility-hidden={$isShowSearchLoader}>
            <div>{ result.title }</div>
            {#if Object.keys(result.list).length }
              <span>{$_('found')}: { result.count }</span>
            {:else}
              <span>{$_('searchNotFound')}</span>
            {/if}
          </div>

          {#each Object.entries(result.list) as [title, folder] (title)}
            <div class="folder">{ title }</div>
            {#each folder as publication (publication.id)}
              <PreviewCard {publication} fixPublication={publication.fix}/>
            {/each}
          {/each}
        {/if}
      </div>
    {/if}
  {/each}
</div>

<style lang="scss">
  .search-results {
    display: flex;
    flex-direction: column;
    gap: 40px;
    @media (min-width: 320px) and (max-width: 1000px) {
      gap: 3px;
    }

    .feed-group-result {
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding-bottom: 16px;
      margin-bottom: 16px;
      border-bottom: 1px solid #EFF1FD;
      @media (min-width: 320px) and (max-width: 1000px) {
        margin-top: 16px;
      }

      > div {
        margin: 0;
        font-size: 20px;
        line-height: 29px;
        font-weight: 600;
        color: #22252C;
      }

      > span {
        font-size: 12px;
        line-height: 18px;
        font-weight: 400;
        color: #8B8F99;
      }
    }

    .folder {
      margin-bottom: 16px;
      font-size: 16px;
      line-height: 23px;
      font-weight: 600;
      color: #22252C;
      @media (min-width: 320px) and (max-width: 1000px) {
        margin-top: 16px;
        margin-bottom: 0;
      }
    }
  }

  .order-1 {
    order: 1;
  }

  .order-2 {
    order: 2;
  }

  .order-3 {
    order: 3;
  }

  .visibility-hidden {
    visibility: hidden;
  }

  .not-found {
    font-size: 30px;
    font-weight: 400;
    line-height: 39px;
    color: #5A5F6D;
    margin-top: 120px;
    display: flex;
    justify-content: center;

    @media (min-width: 320px) and (max-width: 1000px) {
      margin-top: 75px;
      font-size: 20px;
      line-height: 29px;
    }
  }

  .search-title {
    font-size: 26px;
    font-weight: 600;
    line-height: 34px;
    color: #22252C;
    display: flex;
    align-items: end;
    margin-bottom: 24px;

    @media (min-width: 320px) and (max-width: 1000px) {
      font-size: 20px;
      line-height: 29px;
      flex-direction: column;
      align-items: start;
      margin-bottom: 16px;
    }
  }
</style>